import styled from 'styled-components'

const StyledOpacityPopover = styled.div`
  padding: 20px 24px 24px 24px;
  width: 200px;
`

export default StyledOpacityPopover
